const assetsBaseUrl = import.meta.env.VITE_ASSETS_URL;

export const iconUrlByTicker = (ticker: string) => `${assetsBaseUrl}/ticker-logo/${ticker}_icon.svg`;

export const logoUrlByTicker = (ticker: string) => `${assetsBaseUrl}/ticker-logo/${ticker}_logo.svg`;
